import authConstants from '../constants';

export default function () {
    return (dispatch) => {
        dispatch({ type: authConstants.AUTH_CODE_DIALOG_CLOSED });
    }
}